import { render, staticRenderFns } from "./ReceivablePayments.vue?vue&type=template&id=6905db28&"
import script from "./ReceivablePayments.vue?vue&type=script&lang=js&"
export * from "./ReceivablePayments.vue?vue&type=script&lang=js&"
import style0 from "./ReceivablePayments.vue?vue&type=style&index=0&id=6905db28&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports